import React from "react";
import "./Membership.css";

const Membership = () => {
  return (
    <section className="membership-section" id="membership">
      <div className="membership-container">
        <h2 className="membership-title">Membership Plans</h2>
        <p className="membership-subtitle">
          Join our membership for regular care and exclusive discounts
        </p>

        <div className="membership-grid">
          {/* GOLD */}
          <div className="membership-card gold">
            <h3>Gold – Prestige Member</h3>
            <p className="tagline">For premium & luxury car owners</p>

            <ul className="features">
              <li>Luxego Standard Detailing</li>
              <li>Luxego Regular Maintenance</li>
              <li>Luxego Premium Restoration (every 3 months)</li>
            </ul>

            <div className="sizes">
              <span>S<br />£200</span>
              <span>M<br />£250</span>
              <span>L<br />£300</span>
              <span>XL<br />£350</span>
            </div>

            <ul className="benefits">
              <li>Up to 4 visits per month</li>
              <li>20% off on all other detailing services</li>
            </ul>
          </div>

          {/* SILVER */}
          <div className="membership-card">
            <h3>Silver – Care Member</h3>
            <p className="tagline">
              For customers who want their car looking ‘always detailed’
            </p>

            <ul className="features">
              <li>Luxego Standard Detailing</li>
              <li>Luxego Regular Maintenance</li>
              <li>Seasonal Interior-Focused Detailing (every 3 months)</li>
            </ul>

            <div className="sizes">
              <span>S<br />£110</span>
              <span>M<br />£140</span>
              <span>L<br />£165</span>
              <span>XL<br />£190</span>
            </div>

            <ul className="benefits">
              <li>Up to 2 visits per month</li>
              <li>15% off on all other detailing services</li>
            </ul>
          </div>

          {/* BRONZE */}
          <div className="membership-card">
            <h3>Bronze – Maintenance Member</h3>
            <p className="tagline">Best for clean, daily-driven cars</p>

            <ul className="features">
              <li>Luxego Regular Maintenance</li>
            </ul>

            <div className="sizes">
              <span>S<br />£70</span>
              <span>M<br />£80</span>
              <span>L<br />£100</span>
              <span>XL<br />£110</span>
            </div>

            <ul className="benefits">
              <li>Up to 2 visits per month</li>
              <li>10% off on all other detailing services</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Membership;
